import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { BookingsPage } from "@/features/bookings/pages/bookings-page";
import { bookingFilterSchema } from "@/features/bookings/schemas/booking-filter.schema";

export const Route = createFileRoute("/_authenticated/admin/bookings/")({
	head: () => pageTitle("Bookings"),
	component: BookingsPage,
	validateSearch: zodValidator(bookingFilterSchema),
});
